"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHostManifestBuilder = void 0;
var componentsManifestBuilder_1 = require("./componentsManifestBuilder");
function createHostManifestBuilder(_a) {
    var host = _a.host;
    var hostManifest = {
        host: host,
        assets: [],
        components: {},
        shared: [],
        statics: {},
    };
    var componentBuilders = {};
    return {
        addUrl: function (id, url) {
            hostManifest.id = id;
            hostManifest.url = url;
            this.addModelAsset(id, url);
            return this;
        },
        addComponentStatics: function (componentName, statics) {
            hostManifest.statics[componentName] = statics;
            return this;
        },
        addSharedChunkModel: function (chunk, id, url) {
            hostManifest.shared.push({ id: id, url: url });
            hostManifest.assets.push({
                chunk: chunk,
                url: url,
                type: 'model',
                extension: 'js',
            });
            return this;
        },
        addSharedChunkStyleAsset: function (chunk, url) {
            hostManifest.assets.push({
                chunk: chunk,
                url: url,
                type: 'style',
                extension: 'css',
            });
            return this;
        },
        addRuntimeAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'webpack-runtime',
                extension: 'js',
            });
            return this;
        },
        addHotAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'hot',
                extension: 'js',
            });
            return this;
        },
        addModelAsset: function (id, url) {
            hostManifest.assets.push({
                id: id,
                url: url,
                type: 'model',
                extension: 'js',
            });
            return this;
        },
        addStyleAsset: function (url) {
            hostManifest.assets.push({
                url: url,
                type: 'style',
                extension: 'css',
            });
            return this;
        },
        getComponentBuilder: function (name) {
            if (!componentBuilders[name]) {
                componentBuilders[name] = componentsManifestBuilder_1.createComponentManifestBuilder({
                    name: name,
                });
            }
            return componentBuilders[name];
        },
        build: function () {
            var components = {};
            Object.keys(componentBuilders).forEach(function (componentName) {
                components[componentName] = componentBuilders[componentName].build();
            });
            return __assign(__assign({}, hostManifest), { components: components });
        },
    };
}
exports.createHostManifestBuilder = createHostManifestBuilder;
//# sourceMappingURL=hostManifestBuilder.js.map